import { z } from "zod";
export const SeveritySchema = z.enum(["low", "medium", "high", "critical"]);
/** Severity order for sorting and aggregation, most severe first. */
export const SEVERITY_ORDER = ["critical", "high", "medium", "low"];
export const EngineSchema = z.enum(["llm", "gitleaks"]);
/**
 * Findings derived from a repo-local CLAUDE.md / AGENTS.md carry this id. It is
 * reserved so a rule file can never shadow project conventions.
 */
export const RESERVED_RULE_ID = "project-convention";
const KEBAB_CASE = /^[a-z0-9]+(-[a-z0-9]+)*$/;
export const RuleFrontmatterSchema = z.object({
    id: z
        .string()
        .regex(KEBAB_CASE, "id must be kebab-case")
        .refine((v) => v !== RESERVED_RULE_ID, `${RESERVED_RULE_ID} is a reserved id`),
    title: z.string().min(1),
    severity: SeveritySchema,
    scope: z.array(z.string()).default([]),
    tags: z.array(z.string()).default([]),
    enabled: z.boolean().default(true),
    engine: EngineSchema.default("llm"),
});
/** A rule as stored: frontmatter plus everything derived from the file itself. */
export const RuleSchema = RuleFrontmatterSchema.extend({
    group: z.string().min(1),
    body: z.string(),
    filePath: z.string(),
    contentSha: z.string(),
});
/**
 * A rule as delivered to the agent. Severity is already resolved against any
 * project override, so the agent never decides it.
 */
export const RulesetRuleSchema = z.object({
    id: z.string(),
    title: z.string(),
    severity: SeveritySchema,
    engine: EngineSchema,
    body: z.string(),
});
export const RulesetSchema = z.object({
    /** Only engine === "llm" rules. Scanner rules are executed separately. */
    rules: z.array(RulesetRuleSchema),
    gitleaksEnabled: z.boolean(),
});
export const RuleOverrideSchema = z.object({
    ruleId: z.string(),
    enabled: z.boolean().nullable(),
    severity: SeveritySchema.nullable(),
});
export const DEFAULT_RULE_GROUP = "general";
